if (!customElements.get('aaco-card-options')) {
  customElements.define(
    'aaco-card-options',
    class AACOCardOptions extends HTMLElement {
      connectedCallback() {
        if (this.dataset.aacoInitialised === 'true') return;
        this.dataset.aacoInitialised = 'true';

        this.card = this.closest('.card-wrapper');
        this.mainImage = this.card
          ? this.card.querySelector('.card__media .media > img:first-child')
          : null;
        this.status = this.querySelector('[data-aaco-card-status]');
        this.quickAddForm = this.querySelector('.aaco-card-options__form form');
        this.quickAddVariant = this.querySelector('[data-aaco-quick-add-variant]');
        this.quickAddSubmit = this.querySelector('[data-aaco-quick-add-submit]');
        this.colourIndex = Number(this.dataset.colourOptionIndex);
        this.sizeIndex = Number(this.dataset.sizeOptionIndex);
        this.sizeButtons = Array.from(this.querySelectorAll('[data-aaco-size-value]'));
        this.colourSwatches = Array.from(this.querySelectorAll('[data-aaco-colour-value]'));
        this.selectedSwatch = this.querySelector('[data-aaco-colour-value].is-active');

        try {
          var variantData = this.querySelector('[data-aaco-card-variants]');
          this.variants = JSON.parse(variantData ? variantData.textContent : '[]');
        } catch (error) {
          this.variants = [];
        }

        if (this.mainImage) {
          this.originalImage = {
            src: this.mainImage.getAttribute('src'),
            srcset: this.mainImage.getAttribute('srcset'),
            alt: this.mainImage.getAttribute('alt')
          };
        }

        this.colourSwatches.forEach((swatch) => {
          swatch.addEventListener('mouseenter', () => this.preview(swatch));
          swatch.addEventListener('focus', () => this.preview(swatch));
          swatch.addEventListener('mouseleave', () => this.restore());
          swatch.addEventListener('blur', () => this.restore());
          swatch.addEventListener('click', (event) => this.selectColour(event, swatch));
        });

        this.sizeButtons.forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.quickAdd(button);
          });
        });

        var selectedColour = this.selectedSwatch
          ? this.selectedSwatch.dataset.aacoColourValue
          : null;
        this.updateSizes(selectedColour);
      }

      preview(swatch) {
        if (!this.mainImage || !this.originalImage) return;
        var imageUrl = swatch.dataset.aacoCardImage;
        if (!imageUrl) return;

        this.mainImage.removeAttribute('srcset');
        this.mainImage.src = imageUrl;
        this.mainImage.alt =
          swatch.dataset.aacoCardImageAlt || this.originalImage.alt || '';
        if (this.card) this.card.classList.add('aaco-card--variant-preview');
      }

      restore() {
        if (!this.mainImage || !this.originalImage) return;

        if (this.selectedSwatch && this.selectedSwatch.dataset.aacoCardImage) {
          this.preview(this.selectedSwatch);
          return;
        }

        if (this.originalImage.srcset) {
          this.mainImage.setAttribute('srcset', this.originalImage.srcset);
        } else {
          this.mainImage.removeAttribute('srcset');
        }

        if (this.originalImage.src) this.mainImage.src = this.originalImage.src;
        this.mainImage.alt = this.originalImage.alt || '';
        if (this.card) this.card.classList.remove('aaco-card--variant-preview');
      }

      selectColour(event, swatch) {
        event.preventDefault();
        event.stopPropagation();

        this.colourSwatches.forEach((item) => item.classList.remove('is-active'));
        swatch.classList.add('is-active');
        this.selectedSwatch = swatch;
        this.preview(swatch);
        this.updateSizes(swatch.dataset.aacoColourValue);
      }

      updateSizes(colourValue) {
        if (this.sizeIndex < 0 || !this.variants.length) return;

        this.sizeButtons.forEach((button) => {
          var sizeValue = button.dataset.aacoSizeValue;
          var matchingVariants = this.variants.filter((variant) => {
            var sizeMatches = variant.options[this.sizeIndex] === sizeValue;
            var colourMatches =
              this.colourIndex < 0 ||
              !colourValue ||
              variant.options[this.colourIndex] === colourValue;
            return sizeMatches && colourMatches;
          });
          var availableVariant = matchingVariants.find((variant) => variant.available);
          var variant = availableVariant || matchingVariants[0];
          var available = Boolean(availableVariant);

          button.dataset.variantId = variant ? variant.id : '';
          button.disabled = !available;
          button.setAttribute('aria-disabled', available ? 'false' : 'true');
          button.classList.toggle('is-unavailable', !available);
        });
      }

      quickAdd(button) {
        var variantId = button.dataset.variantId;
        if (
          !variantId ||
          button.disabled ||
          button.classList.contains('is-loading') ||
          !this.quickAddForm ||
          !this.quickAddVariant ||
          !this.quickAddSubmit
        ) {
          return;
        }

        button.classList.add('is-loading');
        this.announce('Adding to cart');
        this.quickAddVariant.value = variantId;
        this.quickAddVariant.disabled = false;
        this.quickAddVariant.dispatchEvent(new Event('change', { bubbles: true }));

        if (typeof this.quickAddForm.requestSubmit === 'function') {
          this.quickAddForm.requestSubmit(this.quickAddSubmit);
        } else {
          this.quickAddSubmit.click();
        }

        window.setTimeout(() => {
          button.classList.remove('is-loading');
          button.classList.add('is-added');
          this.announce('Added to cart');
          window.setTimeout(() => button.classList.remove('is-added'), 1200);
        }, 700);
      }

      announce(message) {
        if (this.status) this.status.textContent = message;
      }
    }
  );
}
